import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC, ReactNode } from 'react'

const OverflowImage: FC<{
    children: ReactNode
    containerSx?: SxProps
    float?: 'left' | 'right'
    placeholder: ReactNode
}> = ({ children, containerSx, float, placeholder }) => {
    const positionSx: SxProps = {
        position: 'absolute',
        height: '100%',
        width: 'fit-content',
        zIndex: 4,
        top: '0px',
        ...(float === 'right' ? { right: '0px' } : { left: '0px' }),
    }

    return (
        <Box sx={{ position: 'relative' }}>
            {placeholder}
            <Box sx={{ ...positionSx, ...(containerSx || {}) }}>{children}</Box>
        </Box>
    )
}

export default OverflowImage
